import * as React from "react";
import HtmlTooltip from "common/components/HtmlTooltip/HtmlTooltip";
import { TrophyTypes } from "common/constants/TrophyTypes";

/** Golden Ticket text, or null when the record isnt a ticket. */
export function goldenTicketFlavor(record) {
	return record?.trophyTypeId === TrophyTypes.GoldenTicket &&
		record?.championTeamName
		? `A day one believer - picked ${record.championTeamName} before the tournament began.`
		: null;
}

/** Trophy card label: tickets carry the picked team alongside the event name. */
export function trophyLabel(record) {
	return record?.trophyTypeId === TrophyTypes.GoldenTicket &&
		record?.championTeamName
		? `${record.championTeamName} - ${record.eventName}`
		: record?.eventName;
}

/** Wraps a trophy render in the Golden Ticket flavor tooltip when it applies. */
export default function GoldenTicketTooltip({ record, children }) {
	const flavor = goldenTicketFlavor(record);
	if (!flavor) {
		return children;
	}

	return <HtmlTooltip title={<>{flavor}</>}>{children}</HtmlTooltip>;
}
